import { ControlledInputs, Grid } from '@/components';
import { Stack, Typography } from '@mui/material';
import { RecentActivity } from './RecentActivity';
import { useEditUserFormContext, useGetUser } from '../hooks';

export const ManageProfile = () => {
  const form = useEditUserFormContext();
  const userQuery = useGetUser({
    resetForm: form.reset,
  });

  const { data } = userQuery;

  if (userQuery.isLoading) return;

  return (
    <Stack>
      <Stack
        direction="row"
        justifyContent={'space-between'}
        alignItems="center"
      >
        <Stack direction="row" gap={2} alignItems="center">
          <svg
            width="67"
            height="67"
            viewBox="0 0 67 67"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M66.0418 33.5C66.0418 43.3957 61.625 52.2618 54.6523 58.2317C48.763 63.2818 41.2582 66.0528 33.5002 66.0417C25.4239 66.0417 18.037 63.1011 12.3481 58.2317C8.77309 55.1791 5.90328 51.3868 3.93685 47.1169C1.97043 42.8469 0.954255 38.201 0.958509 33.5C0.958509 15.5282 15.5283 0.958374 33.5002 0.958374C51.472 0.958374 66.0418 15.5282 66.0418 33.5ZM45.3335 23.1459C45.3335 20.0075 44.0868 16.9976 41.8676 14.7784C39.6484 12.5593 36.6386 11.3125 33.5002 11.3125C30.3618 11.3125 27.3519 12.5593 25.1327 14.7784C22.9136 16.9976 21.6668 20.0075 21.6668 23.1459C21.6668 26.2843 22.9136 29.2941 25.1327 31.5133C27.3519 33.7325 30.3618 34.9792 33.5002 34.9792C36.6386 34.9792 39.6484 33.7325 41.8676 31.5133C44.0868 29.2941 45.3335 26.2843 45.3335 23.1459ZM52.7293 51.9157V51.25C52.7293 48.1116 51.4826 45.1018 49.2634 42.8826C47.0443 40.6634 44.0344 39.4167 40.896 39.4167H26.1043C22.9659 39.4167 19.9561 40.6634 17.7369 42.8826C15.5177 45.1018 14.271 48.1116 14.271 51.25V51.9157C14.8824 52.5527 15.5234 53.1591 16.1939 53.735C21.0114 57.8686 27.1524 60.136 33.5002 60.125C37.0945 60.1319 40.6527 59.4077 43.9584 57.9964C47.2641 56.5851 50.2482 54.5163 52.7293 51.9157Z"
              fill="#CBCACA"
            />
          </svg>
          <Stack gap={1}>
            <Typography fontSize={16} fontWeight={700}>
              {`${data?.lastName}, ${data?.firstName}`}
            </Typography>
            <Typography fontSize={12}>{data?.email}</Typography>
          </Stack>
        </Stack>
        <svg
          width="23"
          height="24"
          viewBox="0 0 23 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.0039 3.49815H4.00391C3.47347 3.49815 2.96477 3.70886 2.58969 4.08394C2.21462 4.45901 2.00391 4.96772 2.00391 5.49815V19.4982C2.00391 20.0286 2.21462 20.5373 2.58969 20.9124C2.96477 21.2874 3.47347 21.4982 4.00391 21.4982H18.0039C18.5343 21.4982 19.043 21.2874 19.4181 20.9124C19.7932 20.5373 20.0039 20.0286 20.0039 19.4982V12.4982M17.3789 3.12315C17.7767 2.72533 18.3163 2.50183 18.8789 2.50183C19.4415 2.50183 19.9811 2.72533 20.3789 3.12315C20.7767 3.52098 21.0002 4.06054 21.0002 4.62315C21.0002 5.18576 20.7767 5.72533 20.3789 6.12315L11.3659 15.1372C11.1285 15.3744 10.8351 15.5481 10.5129 15.6422L7.63991 16.4822C7.55386 16.5072 7.46264 16.5088 7.37582 16.4865C7.28899 16.4643 7.20973 16.4191 7.14635 16.3557C7.08297 16.2923 7.0378 16.2131 7.01555 16.1262C6.9933 16.0394 6.99481 15.9482 7.01991 15.8622L7.85991 12.9892C7.95443 12.6672 8.12844 12.3742 8.36591 12.1372L17.3789 3.12315Z"
            stroke="#4C4C4C"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </Stack>
      <Grid columns={2} gap={20} pt={2}>
        <ControlledInputs.TextField
          ControllerProps={{
            control: form.control,
            name: 'firstName',
          }}
          label="First name"
        />
        <ControlledInputs.TextField
          ControllerProps={{
            control: form.control,
            name: 'lastName',
          }}
          label="Last name"
        />
        <ControlledInputs.TextField
          ControllerProps={{
            control: form.control,
            name: 'email',
          }}
          label="Email Address"
        />
        <ControlledInputs.TextField
          ControllerProps={{
            control: form.control,
            name: 'phone',
          }}
          label="Contact #"
        />
      </Grid>
      <RecentActivity />
    </Stack>
  );
};
